export const peoplePlaceHolder = '<?xml version="1.0" encoding="utf-8"?>\n' +
    '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
    '     viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve">\n' +
    '<style type="text/css">\n' +
    '\t.st0{fill:#EFF1FF;z-index: 99999;}\n' +
    '\t.st1{fill:#94A2EE;z-index: 99999;}\n' +
    '</style>\n' +
    '    <rect class="st0" width="200" height="200"/>\n' +
    '    <g>\n' +
    '\t<g>\n' +
    '\t\t<path class="st1" d="M153.5,119.6c-8.3-7.9-10.5-18-12-28.5c-1.3-9.1,0-18.3-1.6-27.3c-2.7-15.7-9.9-28.4-25.1-34.9\n' +
    '\t\t\tc-17.1-7.4-37.3,0.5-47.4,18.1c-4.3,7.5-6.6,15.5-6.5,24.2c0.1,8.9-0.4,17.7-2.2,26.4c-1.7,7.9-4.6,15.1-10.7,21.1\n' +
    '\t\t\tc9.1,5.3,18.6,7.7,28.8,5.4c5.3-1.2,6.6-0.1,4.9,5c-4.1,12.5-13.4,19.3-25.8,22.2c-9.1,2.2-18.2,4.4-26.2,9.7\n' +
    '\t\t\tc-6,4-10.5,9.1-12.7,16.1c-0.5,1.7-1,4.1-3.7,3.1c-2.2-0.8-1.6-2.8-1-4.5c2.8-8.7,8.5-15,16.3-19.7c8.4-5,17.7-7.3,27.1-9.6\n' +
    '\t\t\tc9.3-2.3,16.5-7.3,20.7-16.8c-5.7,0.1-11,0.5-16.3-0.7c-5.9-1.4-11.4-3.7-16.5-7.1c-3.4-2.2-3.4-3.6-0.3-6\n' +
    '\t\t\tc7.1-5.4,9.3-13.2,10.9-21.3C56,86.4,56,78.2,56.1,70c0.3-13.4,4.9-25.2,14.2-34.9c20.3-21.3,52.6-17.3,67.5,8.3\n' +
    '\t\t\tc5.5,9.4,7.8,19.6,7.8,30.4c0,9.7,0.4,19.3,3.3,28.7c1.8,5.9,4.4,11.2,9.8,14.8c2.7,1.8,2.2,3.6-0.3,5.3c-6.6,4.4-14.1,6.4-21.9,7\n' +
    '\t\t\tc-3.7,0.3-7.4,0-11.7,0c3.8,9.9,11,15.3,20.4,17.6c8.8,2.1,17.8,3.9,25.9,8.2c8.8,4.6,15.2,11.3,18.2,20.9c0.5,1.7,0.6,3.3-1.3,4\n' +
    '\t\t\tc-1.8,0.7-2.7-0.6-3.2-2.2c-4-13-14.3-18.8-26.2-22.6c-4.6-1.4-9.4-2.1-14-3.4c-12.5-3.4-21.5-10.4-25.1-23.5\n' +
    '\t\t\tc-0.9-3.2,0.3-4.2,3.3-4c8.2,0.5,16.4,0.8,24.3-2C149.2,121.8,151.4,121.2,153.5,119.6z"/>\n' +
    '\t</g>\n' +
    '</g>\n' +
    '</svg>\n'
